function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("polyline", {
  points: "1 4 1 10 7 10"
});
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("polyline", {
  points: "23 20 23 14 17 14"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
});
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-refresh-ccw"
  }, props), _ref, _ref2, _ref3);
};
export default __webpack_public_path__ + "static/media/refresh-ccw.b37b94cc.svg";
export { SvgComponent as ReactComponent };